import { render, staticRenderFns } from "./CancelBtn.vue?vue&type=template&id=1455302b&"
import script from "./CancelBtn.ts?vue&type=script&lang=js&"
export * from "./CancelBtn.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports